import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function getCaseTypes (token) {
    return axios.get(`${baseUrl}/case/questions/types`, {
        headers: {
            authorization: token
        }
    })
}


export function getCaseQuestionsByType (token, type) {
    return axios.get(`${baseUrl}/case/questions?type=${type}`, {
        headers: {
            authorization: token
        }
    })
}


export function getCaseQuestions (token, query) {
    const q = buildQuery(query);
    return axios.get(`${baseUrl}/case/questions${q}`, {
        headers: {
            authorization: token
        }
    })
}


export function createCaseQuesion (token, data) {
    return axios.post(`${baseUrl}/case/question`, data, {
        headers: {
            authorization: token
        }
    })
}

export function updateCaseQuestion (token, id, data) {
    return axios.patch(`${baseUrl}/case/question/${id}`, data, {
        headers: {
            authorization: token
        }
    })
}

export function deleteQuestion (token, id) {
    return axios.delete(`${baseUrl}/case/question/${id}`, {
        headers: {
            authorization: token
        }
    })
}
